import { TagReadable } from '@crm/api'
import { AnyObject } from 'antd/es/_util/type'
import { DefaultOptionType } from 'antd/lib/select'
import queryString, { StringifiableRecord } from 'query-string'

type Option = {
  value: number
  label: string
  payload: TagReadable
}

export const stringifyUrl = (
  url: string,
  query: StringifiableRecord = {}
): string =>
  queryString.stringifyUrl(
    {
      url,
      query
    },
    { skipEmptyString: true, skipNull: true }
  )

export const generalTransformResults = <T extends TagReadable>(
  results: T[]
): Option[] => {
  return results?.map(({ id, name, ...payload }, i: number) => ({
    value: id,
    label: name || '---',
    key: `${i}--${id}`,
    payload: { ...payload, id, name } as TagReadable
  }))
}

export const listTransformResults = <T extends AnyObject>(
  results: T[]
): DefaultOptionType[] => {
  return results?.map(({ id, title, name, key, label }, i) => ({
    value: key || id,
    label: label || title || name || '---'
  }))
}

export const userTransformResults = <T extends AnyObject>(
  results?: T[]
): DefaultOptionType[] => {
  if (!results) return []

  return results?.map((option) => ({
    label:
      option?.first_name && option?.last_name
        ? `${option.first_name} ${option.last_name}`
        : option?.name || option?.email || '---',
    value: option.id
  }))
}

export const listTransformKeyToString = (
  results: Record<string, any>[]
): DefaultOptionType[] => {
  return results?.map(({ key, label }) => ({
    value: key.toString(),
    label: label || '---'
  }))
}

export const listTransformTemplates = (
  results: Record<string, any>[]
): DefaultOptionType[] => {
  return results?.map(({ id, title }) => ({
    value: id,
    label: title
  }))
}

export const getSelectIdValue = (
  value?: number | string | { label?: string; value?: number | string },
  initialValue?: number | string
) => {
  if (typeof value === 'object' && value !== null && 'value' in value) {
    return value.value
  }

  const isStringValues =
    typeof value === 'string' && typeof initialValue === 'string'
  const isDifferentValues = initialValue !== value

  if (value === undefined && !!initialValue) return null

  if (
    isStringValues &&
    isDifferentValues &&
    value?.length === initialValue?.length
  )
    return value

  if (isStringValues && isDifferentValues) return initialValue

  if (value && !initialValue) return value

  return typeof value === 'number' ? value : initialValue
}
